import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from 'src';
import { PaymentSaveAccounts, PaymentSaveAccountsProperties } from '../payment-save-accounts.component';
import { PaymentPurpose } from '@models/Payment';
import { saveTransactionCardToAccount, TransactionActionType } from '../../../transaction/transaction.actions';
import { toggleModal } from '@common/components/common.actions';

export interface HostedCheckoutCardSaveContainerProperties {
  readonly buttonRef: null | ((button: HTMLButtonElement) => void);
  readonly transactionId?: number;
  readonly isInModal?: boolean;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: HostedCheckoutCardSaveContainerProperties
): Partial<PaymentSaveAccountsProperties> {
  return {
    affiliatedAccounts: state.contract.payment.billableEntities,
    creditCardInitial: {
      number: (state.payment.hostedTransaction.data! || {}).creditCardLastFour || 'XXXX'
    },
    buttonRef: ownProps.buttonRef,
    paymentPurpose: PaymentPurpose.Contract || undefined // ??
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: HostedCheckoutCardSaveContainerProperties
): Partial<PaymentSaveAccountsProperties> {
  return {
    submit: (accountIdBalance: number | undefined, accountIdInitial: number | undefined) => {
      if (!accountIdInitial) {
        return;
      }
      if (!ownProps.transactionId) {
        return;
      }
      dispatch(saveTransactionCardToAccount(ownProps.transactionId, accountIdInitial)).then(
        (action?: { type: TransactionActionType }) => {
          if (!ownProps.isInModal) {
            return;
          }
          if ((action! || {}).type === TransactionActionType.CopyCardToAccountSuccess) {
            dispatch(toggleModal());
          }
        }
      );
    }
  };
}
// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const HostedCheckoutCardSave = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentSaveAccounts);



// WEBPACK FOOTER //
// ./src/payment/_components/gateway/hosted-checkout-card-save-container.ts